import { getLocalDate } from 'pe-core-frontend';
export const formatMessageDates = (messages) => {
    for (const msg of messages) {
        if (msg.params) {
            if (msg.params.from_date) {
                msg.params.from_date = getLocalDate(msg.params.from_date);
            }
            if (msg.params.to_date) {
                msg.params.to_date = getLocalDate(msg.params.to_date);
            }
        }
    }
    return messages;
};
